import React, { type FC, type JSX } from 'react';
import styled from 'styled-components';
import { userSelectNone } from '../../../../../styles/mixins';

const FormatDecoratedContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  height: 52px;
  gap: 24px;
  display: flex;
  flex-direction: row;
  ${userSelectNone}

  div:nth-child(2) {
    &::after {
      content: '–';
      position: absolute;
      left: -24px;
      width: 24px;
      text-align: center;
      margin-bottom: 16px;
    }
  }

  .oss-ui-slider-value-label {
    line-height: 16px;
    text-wrap: nowrap;
  }
`;

const Field = styled.div`
  height: 52px;
  line-height: 52px;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  width: 50%;
  text-align: left;
  border-radius: 8px;
  padding: 0 16px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 18px;
  ${userSelectNone}
`;

const Label = styled.div`
  position: absolute;
  font-size: ${({ theme }) => theme.kallisto.font.size['150']};
  top: 0;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  line-height: 16px;
  margin-top: 6px;
  ${userSelectNone}
`;

type FormatDecoratedProps = {
  min: string;
  max: string;
  minPrice: string;
  maxPrice: string;
  maxPriceSlider: string;
};

const FormatDecorated: FC<FormatDecoratedProps> = (props): JSX.Element => {
  const { min, max, minPrice, maxPrice, maxPriceSlider } = props;

  return (
    <FormatDecoratedContainer className="oss-ui-slider-value-label">
      <Field className="oss-ui-slider-value-label">
        <Label className="oss-ui-slider-value-label">{minPrice}</Label>
        <span>{min}</span>
      </Field>
      <Field className="oss-ui-slider-value-label">
        <Label className="oss-ui-slider-value-label">{maxPrice}</Label>
        <span>{max}</span>
        <span>{max?.toString() === maxPriceSlider?.toString() && '+'}</span>
      </Field>
    </FormatDecoratedContainer>
  );
};

export default FormatDecorated;
